import {AfterViewInit, Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Prodotto} from "../../../models/Prodotto";
import {DxService} from "../../../services/dx.service";
import {DxDataGridComponent} from "devextreme-angular";
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {ServerService} from "../../../services/server.service";
import {ImageZoomComponent} from "../image-zoom/image-zoom.component";

@Component({
   selector: 'app-pv-instances',
   templateUrl: './pv-instances.component.html',
   styleUrls: ['./pv-instances.component.scss'],
   providers: [
      { provide: MAT_DIALOG_DATA, useValue: {} },
   ]
})
export class PvInstancesComponent implements OnInit, AfterViewInit {
   @ViewChild('grid') grid!:DxDataGridComponent
   @ViewChild('imgZoom') imgZoom?;

   @Input() vendorSlug;
   @Input() pVenditaId;
   @Input() clienteId: number | null = null;
   @Input() isModal:boolean = false;
   @Input() pVariantId:any

   @Output() onClickStoricoDDT: EventEmitter<any> = new EventEmitter<any>()
   @Output() onClickAddInstance: EventEmitter<any> = new EventEmitter<any>()

   imageDialog!: MatDialogRef<any>
   Prodotto = Prodotto;
   imageSel:string = ''

   constructor(@Inject(MAT_DIALOG_DATA) public data: any,
               private dxSrv: DxService,
               private dialog: MatDialog,
               private serverSrv: ServerService) {
   }

   ngOnInit(): void {
      console.log(this.clienteId)
   }

   ngAfterViewInit(): void {
      this.initGrid()
   }

   initGrid() {
      this.dxSrv.initGrid(this.grid, {showAdd:false, })
      // this.dxSrv.gridCreateDataSource(`/api/esercizi/${this.vendorSlug}/p_vendita/${this.pVenditaId}/varianti/${this.pVariantId}/instances`, this.grid)
      this.dxSrv.gridCreateDataSource(`/api/esercizi/${this.vendorSlug}/p_vendita/${this.pVenditaId}/prod_var_instances?exclude_no_qta=1&cliente=${this.clienteId}`, this.grid)
      this.grid.onRowPrepared.subscribe((rowInfo:any)=>{
         if(rowInfo.rowType == 'data'){
            if(rowInfo.data.is_deleted){
               console.log(rowInfo)
               $(rowInfo.rowElement).addClass("bg-red-100");
            }
         }
      })
   }

   clickShowOrdiniFor(data) {
      this.onClickStoricoDDT.emit(data)
   }

   clickAddInstance(data) {
      console.log(data)
      this.onClickAddInstance.emit(data)
   }

   openLink(url){
      return this.serverSrv.getPrivateMedia(url)
   }

   openImage(data:any) {
      console.log(data)
      this.imageSel = this.openLink(data.image)

      this.imageDialog = this.dialog.open(ImageZoomComponent, {
         disableClose:false,
         maxWidth: '90vw',
         width: '800px',
         maxHeight: '90vh',
         height: 'auto',
         panelClass: 'my-dialog',
         data:{
            'data':data,
            'vendorSlug':this.vendorSlug,
            'prod_var_instance_id':data.instance,
         }
      });
      this.imageDialog.afterClosed().subscribe(result => {
         // if (result) this.clickOpenModalIstanze(result.pVariant)
      });
   }

   clickClose() {
      this.imageDialog.close()
   }

   setRowColor($e) {
      // console.log($e)
      // if ($e.data.is_deleted){
      //    $e.rowElement.addClass("disabled");
      //
      // }


   }
}
